function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-0822b326\",\"scoped\":true,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector?type=styles&index=0!./bookNavigation.vue")
}
var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./bookNavigation.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0822b326\",\"hasScoped\":true}!../../../vue-loader/lib/selector?type=template&index=0!./bookNavigation.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0822b326",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-book-component/components/bookNavigation/bookNavigation.vue
// module id = 26
// module chunks = 0